import React from "react";
import logo from "../assets/images/maxtronlogo.png";

const Card = ({ title, items, activeItems = [], isTall = false }) => (
  <div
    className={`p-4 sm:p-5 rounded-lg border border-[#333] flex flex-col justify-between shadow-md ${
      isTall ? "min-h-[150px]" : "min-h-[100px]"
    } transition-all duration-300 hover:border-[#C09462] hover:bg-[#1a1a1a] hover:shadow-lg hover:shadow-[#C09462]/20`}
  >
    <h2 className="text-[#C09462] uppercase text-lg sm:text-xl font-semibold mb-3">
      {title}
    </h2>
    <div className="flex flex-wrap gap-x-8 gap-y-2">
      {items.map((item, index) => (
        <span
          key={index}
          className={`${
            activeItems.includes(index) ? "text-[#EAE2C3]" : "text-[#EAE2C3]"
          } 
          hover:text-[#FED334] text-xs sm:text-sm md:text-[16px] py-1 px-0.5 rounded transition-colors`}
        >
          {item}
        </span>
      ))}
    </div>
  </div>
);

const SampleVideo = () => {
  return (
    <div className="min-h-screen flex flex-col items-center py-10 px-4 sm:px-8 relative overflow-x-hidden overflow-y-auto border-t-[#C09462] border-t-[2px] border-b-[#C09462] border-b-[2px]">
      <div className="absolute inset-0 w-full h-full z-0 opacity-30">
        <img
          src="/images/bgplain.svg"
          alt="background"
          className="w-full h-full object-cover"
        />
      </div>

      <div className="absolute top-0 left-0 w-full h-full opacity-10 z-0 pointer-events-none">
        <svg
          className="w-full h-full"
          viewBox="0 0 1440 810"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1200.72 201.59C1306.49 201.59 1358.38 273.74 1358.38 340.52V469.83C1358.38 536.61 1306.49 608.76 1200.72 608.76H239.28C133.51 608.76 81.62 536.61 81.62 469.83V340.52C81.62 273.74 133.51 201.59 239.28 201.59H1200.72Z"
            stroke="#D4AF37"
            strokeWidth="0.5"
            strokeDasharray="2 2"
          />
          <path
            d="M1358.38 340.52L1439.69 340.52"
            stroke="#D4AF37"
            strokeWidth="0.5"
            strokeDasharray="2 2"
          />
          <path
            d="M0.3125 340.52L81.6225 340.52"
            stroke="#D4AF37"
            strokeWidth="0.5"
            strokeDasharray="2 2"
          />
          <path
            d="M1358.38 469.83L1439.69 469.83"
            stroke="#D4AF37"
            strokeWidth="0.5"
            strokeDasharray="2 2"
          />
          <path
            d="M0.3125 469.83L81.6225 469.83"
            stroke="#D4AF37"
            strokeWidth="0.5"
            strokeDasharray="2 2"
          />
          <path
            d="M1066.01 405.17L1066.01 608.76"
            stroke="#D4AF37"
            strokeWidth="0.5"
            strokeDasharray="2 2"
          />
          <path
            d="M373.99 405.17L373.99 608.76"
            stroke="#D4AF37"
            strokeWidth="0.5"
            strokeDasharray="2 2"
          />
          <path
            d="M720 201.59V608.76"
            stroke="#D4AF37"
            strokeWidth="0.5"
            strokeDasharray="2 2"
          />
        </svg>
      </div>
      <h1 className="text-[#EAE2C3] text-5xl font-light self-start mb-16 mt-8 z-10 pl-8 md:pl-20">
        Our Ecosystem
      </h1>
      <div className="w-full max-w-7xl z-10 px-4 sm:px-6">
        <div className="flex justify-center items-center py-4 mb-8 sm:mb-12">
          <div className="w-20 h-20 sm:w-28 sm:h-28 md:w-36 md:h-36 rounded-full flex items-center justify-center border-2 border-[#4B4B4B] shadow-lg bg-black/50">
            <img
              src={logo}
              alt="Maxtron Logo"
              className="w-3/4 h-3/4 object-contain"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 w-full">
          <Card
            title="Cross Border Fund"
            items={["Dubai", "USA", "India"]}
            activeItems={[0]}
          />
          <Card
            title="Trading House"
            items={[" Precious Metals", "Copper", "Gold"]}
          />
          <Card title="Digital Assets" items={["BTC", "Crypto", "RWA"]} />
          <Card title="SPORTS" items={["Teams"]} />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6 w-full mt-8 sm:mt-10 px-4 sm:px-8">
          <Card title="DEEP TECH" items={["MAXTRON"]} isTall={true} />
          <Card
            title="REAL ESTATE"
            items={["VARA", "DLD", "RERA"]}
            isTall={true}
          />
          <Card title="D2C" items={["Accelerator"]} isTall={true} />
        </div>
      </div>
    </div>
  );
};

export default SampleVideo;
